"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureBox = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var feature_box_svg_1 = __importDefault(require("./feature-box.svg"));

var component_library_waas_templates_constants_1 = require("@tradesorg/component-library-waas-templates.constants");

require("./template-1-feature-box.css");

function FeatureBox(_a) {
  var classNameCustom = _a.classNameCustom,
      position = _a.position,
      icon = _a.icon,
      numberClients = _a.numberClients,
      text = _a.text,
      backgroundIcon = _a.backgroundIcon,
      clearBgContainerIcon = _a.clearBgContainerIcon,
      rest = __rest(_a, ["classNameCustom", "position", "icon", "numberClients", "text", "backgroundIcon", "clearBgContainerIcon"]);

  var left = position && position === 'left';
  return react_1.default.createElement("div", Object.assign({}, rest, {
    className: "container-box max-w-sm h-auto bg-white lg:px-10 lg:py-8 xs:px-8 xs:py-5 flex items-stretch  ".concat(!left && 'flex-row-reverse justify-end', " ").concat(classNameCustom)
  }), react_1.default.createElement("div", {
    className: "items-center justify-center w-24 h-24 rounded-none border-all ".concat(!clearBgContainerIcon && 'container-icon', " grid ").concat(!left && 'ml-6', " ").concat(backgroundIcon)
  }, react_1.default.createElement("img", {
    src: icon,
    alt: ""
  })), react_1.default.createElement("div", {
    className: "flex flex-col h-24 justify-center ".concat(left && 'ml-6')
  }, react_1.default.createElement("div", {
    className: "text-3xl not-italic font-medium text-left"
  }, numberClients), react_1.default.createElement("div", {
    className: "lg:text-base xs:text-sm not-italic font-normal text-left"
  }, text)));
}

exports.FeatureBox = FeatureBox;
FeatureBox.propTypes = {
  icon: prop_types_1.default.element,
  numberClients: prop_types_1.default.string,
  text: prop_types_1.default.string,
  backgroundIcon: prop_types_1.default.string,
  classNameCustom: prop_types_1.default.string,
  clearBgContainerIcon: prop_types_1.default.bool,
  position: prop_types_1.default.arrayOf(component_library_waas_templates_constants_1.FEATURE_BOX_POSITION)
};
FeatureBox.defaultProps = {
  icon: feature_box_svg_1.default,
  numberClients: '387',
  text: 'happy, clients',
  position: 'left',
  clearBgContainerIcon: false,
  backgroundIcon: ''
};